import React, { useRef } from "react";
import { Navigation } from "./navigation";
import { Footer } from "./Footer";
import { FoundationTestSeries } from "./FoundationTestSeries";

const FoundationPlanLists = () => {
    const childRef = useRef();
    const cartNumberUpdate = () => {
        if (childRef.current !== null || childRef.current !== undefined) {
            try {
                childRef.current.update();
            } catch (error) {
                console.log(error);
            }

        }

    }

    return (
        <div>
            {/* <Navigation ref={childRef} /> */}
            <FoundationTestSeries cartNumberUpdate={cartNumberUpdate} />
            {/* <Footer /> */}
        </div>
    )
};

export default FoundationPlanLists;